import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../theme';
import { Heading2 } from '../../shared/Typography';
import { StyledFaqsSection } from '../shared/Faqs.styled';

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding: ${spacing('xl4')} ${spacing('md')};

  ${Heading2} {
    text-align: center;
    margin-bottom: ${spacing('lg')};
  }

  ${StyledFaqsSection} {
    padding-top: ${spacing('xl4')};
    padding-bottom: 0;
  }
`;

export const StyledCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const StyledCard = styled.div`
  max-width: 20rem;
  margin-left: auto;
  margin-right: auto;
  background-color: ${color('white')};
  padding: ${spacing('xl')};
  border-radius: ${radius('md')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    max-width: unset;
  }

  p {
    margin: 0;
    line-height: 1.5;
    flex-grow: 1;
  }
`;

export const StyledCardIcon = styled.img`
  width: 5rem;
  height: 5rem;
`;

export const StyledCardSeparator = styled.span`
  width: ${spacing('xl')};
  height: ${spacing('xs2')};
  background-color: ${color('cyan_700')};
`;

export const StyledCardTitle = styled.h4`
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('black')};
  margin: 0;
`;

export const StyledCardLink = styled.a`
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  padding-top: ${spacing('sm')};
  margin-top: auto;
`;
